import { Firestore } from '../../config/firebase'
import { collection } from 'firebase/firestore'
import FirebaseResults from './firebase_results'

const FirebaseEmployees = collection(Firestore, 'employees')
const FirebaseTeams = collection(Firestore, 'teams')
const FirebaseRaces = collection(Firestore, 'races')
const FirebaseClubs = collection(Firestore, 'clubs')

export { FirebaseEmployees, FirebaseResults, FirebaseTeams, FirebaseRaces, FirebaseClubs }
